import type { ReactNode } from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import "./ui.css";

/**
 * Ein Modal-Primitive auf Radix — ersetzt die hand-gebauten Backdrops
 * (`crop-backdrop`, `qv-dialog` …) und bringt Fokus-Falle, Escape-Schließen und
 * Portal von Haus aus mit. Der Consumer stylt seinen Kasten über
 * `contentClassName` (z. B. die bestehende `crop-modal`-Klasse).
 */
export function Dialog({
  open,
  onClose,
  title,
  children,
  contentClassName,
}: {
  open: boolean;
  onClose: () => void;
  /** Für Screenreader — auch wenn der Kasten eine sichtbare Überschrift hat. */
  title: string;
  children: ReactNode;
  contentClassName?: string;
}) {
  return (
    <RadixDialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="ui-dialog-overlay" />
        <RadixDialog.Content
          className={`ui-dialog-content${contentClassName ? ` ${contentClassName}` : ""}`}
        >
          <RadixDialog.Title className="sr-only">{title}</RadixDialog.Title>
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
